<template>
  <div class="d-flex flex-wrap filter-list">
    <multi-select
      label="Team: "
      class="filter"
      :options="teamsOptions"
      :values="filterDetails.teams || []"
      menu-alignment="right"
      @change="onFilter('teamIds', $event)"
      placeholder="Choose teams"
      id="template-filter-teams"
    >
    </multi-select>
    <multi-select
      label="Role: "
      class="filter"
      :options="rolesOptions"
      :values="filterDetails.roles || []"
      menu-alignment="right"
      @change="onFilter('roleIds', $event)"
      placeholder="Choose roles"
    >
    </multi-select>
    <multi-select
      label="Company: "
      class="filter"
      :options="companiesOptions"
      :values="filterDetails.companies || []"
      menu-alignment="right"
      @change="onFilter('companyIds', $event)"
      placeholder="Choose companies"
    >
    </multi-select>
    <feature-tooltip
      heading="See templates by teams"
      message="Product, Marketing and Sales or filter by Role or Company. See Goal templates relevant to you."
      target="template-filter-teams"
      :storageKey="STORAGE_FLAGS.templateTeamFilterSeen"
      placement="bottom"
    />
  </div>
</template>

<script>
import FeatureTooltip from '@/components/FeatureTooltip'
import MultiSelect from '@/components/form/MultiSelect'
import { STORAGE_FLAGS } from '@/constants/storage'
import * as R from 'ramda'
import { goalTemplatesFilterDefaultState } from '@/constants/learn'

/**
 * This is the filters for Goal Templates
 */
export default {
  name: 'TemplatesFilters',
  props: ['teams', 'roles', 'companies', 'filterData'],
  components: {
    MultiSelect,
    FeatureTooltip
  },
  data() {
    return {
      emptiedFilterMap: {},
      STORAGE_FLAGS
    }
  },
  computed: {
    allTeamsOptions() {
      let allTeams = this.teams.map(team => ({
        ...team,
        label: team.title
      }))
      return [...goalTemplatesFilterDefaultState.teams, ...allTeams]
    },
    teamsOptions() {
      let allTeams = this.allTeamsOptions
      if (this.filterDetails.teams?.length > 0) {
        // remove "All" option
        allTeams = allTeams.filter(x => x.id !== -1)
      }
      return R.differenceWith((x, y) => x.id === y.id, allTeams, this.filterDetails.teams || [])
    },
    allRolesOptions() {
      let allRoles = this.roles.map(team => ({
        ...team,
        label: team.title
      }))
      return [...goalTemplatesFilterDefaultState.roles, ...allRoles]
    },
    rolesOptions() {
      let allRoles = this.allRolesOptions
      if (this.filterDetails.roles?.length > 0) {
        // remove "All" option
        allRoles = allRoles.filter(x => x.id !== -1)
      }
      return R.differenceWith((x, y) => x.id === y.id, allRoles, this.filterDetails.roles || [])
    },
    allCompaniesOptions() {
      let allCompanies = this.companies.map(company => ({
        ...company,
        label: company.title
      }))
      return [...goalTemplatesFilterDefaultState.companies, ...allCompanies]
    },
    companiesOptions() {
      let allCompanies = this.allCompaniesOptions
      if (this.filterDetails.companies?.length > 0) {
        // remove "All" option
        allCompanies = allCompanies.filter(x => x.id !== -1)
      }
      return R.differenceWith(
        (x, y) => x.id === y.id,
        allCompanies,
        this.filterDetails.companies || []
      )
    },
    filterDetails() {
      let filterData = {
        teams: this.filterData.teamIds
          ?.split(',')
          .map(teamId => this.allTeamsOptions.find(team => team.id === +teamId))
          .filter(Boolean),
        roles: this.filterData.roleIds
          ?.split(',')
          .map(roleId => this.allRolesOptions.find(role => role.id === +roleId))
          .filter(Boolean),
        companies: this.filterData.companyIds
          ?.split(',')
          .map(companyId => this.allCompaniesOptions.find(company => company.id === +companyId))
          .filter(Boolean)
      }
      if (!this.emptiedFilterMap.teamIds && (filterData.teams || []).length === 0) {
        filterData.teams = goalTemplatesFilterDefaultState.teams
      }
      if (!this.emptiedFilterMap.roleIds && (filterData.roles || []).length === 0) {
        filterData.roles = goalTemplatesFilterDefaultState.roles
      }
      if (!this.emptiedFilterMap.companyIds && (filterData.companies || []).length === 0) {
        filterData.companies = goalTemplatesFilterDefaultState.companies
      }
      return filterData
    }
  },
  methods: {
    onFilter(field, value) {
      let valueIds = value.map(x => x.id)
      if (valueIds.length === 0) {
        this.emptiedFilterMap = { ...this.emptiedFilterMap, [field]: true }
      } else if (valueIds.length > 1) {
        valueIds = valueIds.filter(x => x !== -1)
      }
      this.$emit('change', { field, fieldValue: valueIds })
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.filter-list {
  gap: 12px;
}

@include media-breakpoint-down(sm) {
  .filter {
    flex-basis: 100%;
  }
}
</style>
